import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";

const fetchEventCondition = (eventIdx) => {
	return api.get("/event-condition/" + eventIdx + "/grade").then((data) => data.data);
};

export const useEventConditionQuery = (eventIdx) => {
	return useQuery({
		retry: 0,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		queryKey: ["application", eventIdx],
		queryFn: () => fetchEventCondition(eventIdx),
		// enabled: false,
		select: (data) => {
			return data.data;
		},
	});
};
